import React from 'react';
import FilterTable from './filterTable';
import { ClientTableColumnCaptions } from './tableColumnCaptions';
import { jsonColumn } from './tableUtils';

const ClientHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: { type: 'datetime' },
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'previous',
    text: 'Previous values',
    filter_: { type: 'text' },
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="clientsHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previous: jsonColumn(histrec.previousValues, ClientTableColumnCaptions)
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no client history records"
    />
  );
};

export default ClientHistoryTable;



// WEBPACK FOOTER //
// ./src/components/clientHisotryTable.js